import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from "../../services/user.service";

const CapabilityModal = (props) => {
  const { isSubmitting } = useState(false);
  const [checkedAdminCapabilities, setCheckedAdminCapabilities] = useState([]);
  const [checkedProductCapabilities, setCheckedProductCapabilities] = useState([]);
  const [adminCapabilities, setAdminCapabilities] = useState([]);
  const [productCapabilities, setProductCapabilities] = useState([]);
  
  const modalClose = () => {
    props.closeModal(false, []);
  }

  useEffect(() => {
    const membership = props.user?.user_subsites?.[0];
    setCheckedAdminCapabilities((membership?.capabilities || []).map((c) => c.id));
    setCheckedProductCapabilities(
      (membership?.productCapabilities || membership?.product_capabilities || []).map((c) => c.id)
    );

    Promise.all([
      UserService.getCapabilities(),
      UserService.getProductCapabilities()
    ]).then(
      ([adminCaps, productCaps]) => {
        setAdminCapabilities(Array.isArray(adminCaps) ? adminCaps : []);
        setProductCapabilities(Array.isArray(productCaps) ? productCaps : []);
      },
      (error) => {
        console.log(error?.response || error?.message || error);
      }
    );
  }, [props.user]);

  const toggleId = (list, setList, id) => {
    const parsed = parseInt(id, 10);
    if (list.includes(parsed)) {
      setList(list.filter((item) => item !== parsed));
    } else {
      setList([...list, parsed]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await UserService.setCapabilities({
      userId: props.user.id,
      capabilities: checkedAdminCapabilities
    });
    await UserService.setProductCapabilities({
      userId: props.user.id,
      capabilities: checkedProductCapabilities
    });

    const adminList = adminCapabilities.filter((c) => checkedAdminCapabilities.includes(c.id));
    const productList = productCapabilities.filter((c) => checkedProductCapabilities.includes(c.id));
    props.closeModal(true, { admin: adminList, product: productList });
  };

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Capabilities<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Admin capabilities</Form.Label>
                <Form.Text className="d-block text-muted mb-2">
                  Control access to admin tools (users, surveys, reports, etc.).
                </Form.Text>
                {adminCapabilities.map((capability) => (
                  <Form.Check
                    key={"admin-capability" + capability.id}
                    type="switch"
                    id={"admin-" + capability.id}
                    label={capability.capabilityName}
                    checked={checkedAdminCapabilities.includes(capability.id)}
                    onChange={(e) => toggleId(checkedAdminCapabilities, setCheckedAdminCapabilities, capability.id)}
                  />
                ))}
                {adminCapabilities.length === 0 && (
                  <div className="text-muted">No admin capabilities defined.</div>
                )}
              </Form.Group>

              <hr />

              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Product capabilities</Form.Label>
                <Form.Text className="d-block text-muted mb-2">
                  Control which catalog products and menu categories this user can see.
                </Form.Text>
                {productCapabilities.map((capability) => (
                  <Form.Check
                    key={"product-capability" + capability.id}
                    type="switch"
                    id={"product-" + capability.id}
                    label={capability.capabilityTitle
                      ? `${capability.capabilityName} (${capability.capabilityTitle})`
                      : capability.capabilityName}
                    checked={checkedProductCapabilities.includes(capability.id)}
                    onChange={() => toggleId(checkedProductCapabilities, setCheckedProductCapabilities, capability.id)}
                  />
                ))}
                {productCapabilities.length === 0 && (
                  <div className="text-muted">No product capabilities defined.</div>
                )}
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Update Capabilities
                </Button>
              </Modal.Footer>
            </Form>  
    </Modal.Body>
    </Modal>
  );
};

export default CapabilityModal;
